import { X } from 'phosphor-react'

import { Modal } from '../Modal'
import { Column, Row } from '../Grid'
import { NextImage } from '../NextImage'

import { getYouTubeVideoId } from 'utils/helpers'

const Avatar = ({ psycho, isOpen, setIsOpen }) => {
  return (
    <Row width='100%' height='100%'>
      <NextImage
        width={130}
        height={130}
        layout='intrinsic'
        borderRadius='100%'
        src={psycho.social_thumb || '/static/images/psicologo-sem-foto.png'}
        alt={`Imagem do perfil do psicólogo ${psycho.name}`}
        itemprop='image'
        priority
        style={{ cursor: 'pointer' }}
      />
      {psycho.video_url && (
        <Row position='absolute'>
          <NextImage
            onClick={() => setIsOpen(open => !open)}
            borderRadius='100%'
            width={130}
            height={130}
            src='/static/images/play_button.png'
            style={{ cursor: 'pointer' }}
          />
        </Row>
      )}
      <Modal
        isOpened={isOpen}
        setIsOpened={open => setIsOpen(open => !open)}
        shouldCloseOnClickOutside={true}
        shouldCloseOnEscape={true}
        withBackground={true}
      >
        {({ innerModalRef }) => (
          <Column
            maxWidth={['100%', '95%', '872px']}
            maxHeight={['95vh', '90vh', '95%']}
            width='100%'
            backgroundColor='white'
            borderRadius='10px'
            overflowY='auto'
            ref={innerModalRef}
            margin={['8px', '8px', '0 auto']}
          >
            <Column alignItems='flex-end' px={['8px', '8px', '16px']} py='12px' cursor='pointer'>
              <X size={20} cursor='pointer' onClick={() => setIsOpen(open => !open)} />
            </Column>
            <Column width='100%' px={['16px', '16px', '32px']} textAlign='left'>
              <Row
                className='embed-responsive embed-responsive-21by9'
                box-shadow='0px 7px 16px 3px #c8c8c8'
                background='#000'
                width='100%'
                mb='30px'
              >
                <iframe
                  className='embed-responsive-item'
                  src={`https://www.youtube.com/embed/${getYouTubeVideoId(psycho.video_url)}`}
                  allow='autoplay; encrypted-media'
                  allowfullscreen
                />
              </Row>
            </Column>
          </Column>
        )}
      </Modal>
    </Row>
  )
}

export default Avatar
